"use strict";
var ENV;
(function (ENV_1) {
    ENV_1.ENV = 'production';
    ENV_1.ConnectSetting = {
        baseURL: 'https://api-management.ekispert.jp/v1',
        aws: {
            region: 'ap-northeast-1',
            identityPoolId: 'ap-northeast-1:2e4cd56d-f04c-4992-ac15-e195236f6aff',
            userPoolId: 'ap-northeast-1_FziE6m2zU',
            clientId: '5ns178svqdvd681qmst5t7rtnp',
        },
        cookie: {
            path: '/',
            secure: true,
        }
    };
})(ENV || (ENV = {}));
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ENV;



//////////////////
// WEBPACK FOOTER
// ./build/js/env.js
// module id = 748
// module chunks = 0 1 2 3 4 5 6 7 8